import { useMemo } from "react";
import { useQueryClient } from "react-query";
import { useParams } from "react-router-dom";
import API from "../../../services/API";
import { useContext } from "react";
import ToastContext from "../../../services/Context/ToastContext"
import uuid from 'react-uuid';
import useReorderSections from "./useReorderSections";
import { txt } from "../../../services/translation";

export default function useCreateSection(){

    const {id} = useParams()

    const {setToast} = useContext(ToastContext)

    const queryClient = useQueryClient()

    const queryKey = useMemo(() => ['design', id, 'sections'], [id]);

    const reorderSections = useReorderSections();

    return (chapter) => {

        const oldSections = [...queryClient.getQueryData(queryKey)];

        let newRank = oldSections.filter(s => s.chapter?.id === chapter.id).length + 1;

        let newSection = {
            id: uuid(),
            title: '',
            rank: newRank,
            chapter: chapter,
            type: {id: 'video'},
            process: null,
            category: null,
            incrementCompletion: true,
            required: false,
            edit: true
        }

        let newSections = [...queryClient.getQueryData(queryKey)];
        newSections.push(newSection);
        newSections = reorderSections(newSections);
        queryClient.setQueryData(queryKey, newSections);

        newSection = newSections.find(s => s.id === newSection.id)

        API.post(`/design/sections`, newSection)
            .then(r => {
                console.log(r.data)
                API.put('/design/sections/reorder', newSections)
            })
            .catch(() => {
                queryClient.setQueryData(queryKey, oldSections)

                setToast({
                    severity: 'error',
                    message: txt('errorOccurred')
                })
            })
    }
}